export const headerPaneNames = ['myDay', 'notifications', 'teamsChat', 'rewards'] as const;

export type HeaderPaneName = typeof headerPaneNames[number];
